import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { Box, Button, Flex, FormControl, FormLabel, Grid, Switch } from '@chakra-ui/react';
import { AdminListPageLayout } from '../../components/admin-list-page-layout/admin-list-page-layout';
import { BreadCrumbsComponent } from '../../components/breadcrumbs/breadcrumbsComponent';
import { useDispatch, useSelector } from 'react-redux';
import ConfigurationHistoryDrawer from './configuration-history-drawer';
import { fetchConfigDetail, listConfigurations, toggleConfigDrawer, toggleConfigDrawerContent } from '../../actions/configurations';
import ConfigurationsTable from './ConfigurationsTable';
import { useHistory, useParams } from 'react-router-dom';
import ConfigurationDetailDrawer from './configuration-detail-drawer';
const ConfigurationManagement = (props)=>{
    const tenantId = props.tenantId || 'defaultTenantId';
    const tenantName = props.tenantName || tenantId;
    const dispatch = useDispatch();
    const history = useHistory();
    const { configId, orgId } = useParams();
    const configurations = useSelector((state)=>state.configurations.configurations);
    const configDetail = useSelector((state)=>state.configurations.configurationDetail);
    const activeContext = useSelector((state)=>state.ui.context.activeContext);
    const { serviceLines = [], organizationCode, organizationId } = activeContext || {};
    const isDrawerOpen = useSelector((state)=>state.configurations.isDrawerOpen);
    const [isHistoryDrawerOpen, setIsHistoryDrawerOpen] = useState(false);
    const [showSystemConfigs, setShowSystemConfigs] = useState(false);
    // Determine if we should show the system config toggle
    const shouldShowSystemToggle = orgId === '1';
    // Determine the effective tenant ID based on toggle state
    const effectiveTenantId = shouldShowSystemToggle && showSystemConfigs ? '*' : tenantId;
    // Fetch the list of configurations on mount and when toggle changes
    useEffect(()=>{
        dispatch(listConfigurations({
            tenantId: effectiveTenantId
        }));
    }, [
        dispatch,
        effectiveTenantId
    ]);
    // If there's a configId in the route, fetch its detail and open the drawer
    useEffect(()=>{
        if (configId) {
            dispatch(fetchConfigDetail({
                configurationId: configId,
                tenantId: effectiveTenantId
            }));
            dispatch(toggleConfigDrawer(true));
            dispatch(toggleConfigDrawerContent(true));
        }
    }, [
        configId,
        effectiveTenantId,
        dispatch
    ]);
    // Close the drawer and navigate back to the configurations list
    const handleDrawerClose = ()=>{
        dispatch(toggleConfigDrawer(false));
        dispatch(toggleConfigDrawerContent(false));
        history.push(`/cmx/admin/orgs/${orgId}/configurations`);
    };
    // Handle system config toggle change
    const handleSystemToggleChange = (checked)=>{
        setShowSystemConfigs(checked);
    };
    return /*#__PURE__*/ _jsxs(AdminListPageLayout, {
        children: [
            /*#__PURE__*/ _jsx(Grid, {
                flexShrink: 0,
                children: /*#__PURE__*/ _jsx(Flex, {
                    children: /*#__PURE__*/ _jsx(BreadCrumbsComponent, {})
                })
            }),
            /*#__PURE__*/ _jsx(Grid, {
                flex: "1 1 0",
                minHeight: 0,
                display: "flex",
                flexDirection: "column",
                children: /*#__PURE__*/ _jsxs(Box, {
                    position: "relative",
                    flex: "1 1 0",
                    minHeight: 0,
                    display: "flex",
                    flexDirection: "column",
                    children: [
                        /*#__PURE__*/ _jsxs(Flex, {
                            justify: "space-between",
                            align: "center",
                            mb: 2,
                            flexShrink: 0,
                            children: [
                                /*#__PURE__*/ _jsx(Box, {
                                    children: shouldShowSystemToggle && /*#__PURE__*/ _jsxs(FormControl, {
                                        display: "flex",
                                        alignItems: "center",
                                        children: [
                                            /*#__PURE__*/ _jsx(FormLabel, {
                                                htmlFor: "system-config-toggle",
                                                mb: "0",
                                                fontSize: "sm",
                                                children: "Show System-Level Configurations"
                                            }),
                                            /*#__PURE__*/ _jsx(Switch, {
                                                id: "system-config-toggle",
                                                isChecked: showSystemConfigs,
                                                onChange: (e)=>handleSystemToggleChange(e.target.checked),
                                                colorScheme: "blue",
                                                size: "sm"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx(Button, {
                                    onClick: ()=>setIsHistoryDrawerOpen(true),
                                    colorScheme: "blue",
                                    variant: "outline",
                                    size: "sm",
                                    children: "View Change History"
                                })
                            ]
                        }),
                        activeContext && /*#__PURE__*/ _jsx(ConfigurationsTable, {
                            configurations: configurations,
                            serviceLines: serviceLines,
                            orgCode: orgId,
                            tenantId: effectiveTenantId
                        })
                    ]
                })
            }),
            configId && activeContext && /*#__PURE__*/ _jsx(ConfigurationDetailDrawer, {
                isOpen: isDrawerOpen,
                onClose: handleDrawerClose,
                configDetail: configDetail && configDetail.length ? configDetail[0] : null,
                serviceLines: serviceLines,
                tenantId: effectiveTenantId
            }),
            activeContext && /*#__PURE__*/ _jsx(ConfigurationHistoryDrawer, {
                isOpen: isHistoryDrawerOpen,
                onClose: ()=>setIsHistoryDrawerOpen(false),
                tenantId: effectiveTenantId,
                tenantName: tenantName
            })
        ]
    });
};
export default ConfigurationManagement;
